<template>
<v-container>
    <v-row>
        <v-col style="text-align: center;">
            <div>Development supported by an independent grant from EMD Serono</div>
            All rights reserved
        </v-col>
    </v-row>
</v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>